export const loaderFinished = 'LOADER_FINISHED';
export const loaderStarted = 'LOADER_STARTED';
